import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const cardsWithButton = css({});

export const cardscomponent = css({
  padding: '24px 24px',
  minHeight: '200px',
  background: '#fff',
  border: '#f4f3f0 solid 2px',
  marginBottom: '32px',
  borderRadius: '16px',
  cursor: 'pointer',
  display: 'flex',

  width: '100%',
  textDecoration: 'none',

  ':hover': { boxShadow: '0px 10px 80px rgb(0 0 0 / 8%)', outline: 'none' },

  [MediaQueries.sm]: {
    minHeight: 'unset',
    width: '100%',
    marginBottom: '16px',
  },
  [MediaQueries.xl]: {
    maxWidth: '192px',
  },
  [MediaQueries.lg]: { minHeight: '135px' },
  [MediaQueries.md]: { minHeight: '135px' },

  '.card_sec': {
    textAlign: 'left',
    [MediaQueries.sm]: {
      maxWidth: 'initial',
      display: 'flex',
      alignItems: 'end',
    },
    [MediaQueries.md]: {
      maxWidth: 'initial',
      display: 'flex',
      alignItems: 'end',
    },
    [MediaQueries.lg]: {
      maxWidth: 'initial',
      display: 'flex',
      alignItems: 'end',
    },
    '.textsec': {
      [MediaQueries.sm]: {
        marginLeft: '21px',
      },
      [MediaQueries.md]: {
        marginLeft: '21px',
      },
      [MediaQueries.lg]: {
        marginLeft: '21px',
      },
    },

    h3: {
      fontSize: '16px',
      fontStyle: 'normal',
      marginTop: '16px',
      marginBottom: '8px',
      color: '#e52500',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      [MediaQueries.sm]: {
        marginTop: '0px',
      },
      [MediaQueries.md]: {
        marginTop: '0px',
      },
      [MediaQueries.lg]: {
        marginTop: '0px',
      },

      span: {
        borderBottom: '#fad3cc solid 1px',
      },
    },

    p: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      color: '#858585',
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      margin: '0',
    },

    img: {
      maxWidth: '44px',
      width: 'auto',
      [MediaQueries.sm]: {
        maxWidth: '37px',
      },
      [MediaQueries.md]: {
        maxWidth: '37px',
      },
      [MediaQueries.lg]: {
        maxWidth: '37px',
      },
    },
  },
});
